import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import PropTypes from 'prop-types';
import { Icon } from 'antd-mobile';
import Radio from '../../routes/routes/feeQuery/routes/detail/components/Radio';

import './index.less';
import Btn from 'Btn';

let popPwdQueue = [];

class PopPwdComponent extends Component {
  static props = {
    title: PropTypes.string,
    destroy: PropTypes.func,
    onConfirm: PropTypes.func,
    onCancel: PropTypes.func,
    renderHtml: PropTypes.bool,
    nameList: PropTypes.array,
    lang: PropTypes.object,
  };

  static defaultProps = {
    title: '',
    destroy: () => {},
    onConfirm: (destroy, value) => {
      destroy && destroy();
    },
    onCancel: destroy => {
      destroy && destroy();
    },
  };

  state = {
    value: '',
    inCoudesOne: true,
    inCoudesTwo: false,
  };

  onChange = e => {
    this.setState({ value: e.target.value });
  };

  readingF = key => () => {
    if (key == 'inCoudesOne' && !this.state[key]) {
      this.setState({ [key]: !this.state[key] });
      this.setState({ inCoudesTwo: this.state[key] });
    }
    if (key == 'inCoudesTwo' && !this.state[key]) {
      this.setState({ [key]: !this.state[key] });
      this.setState({ inCoudesOne: this.state[key] });
    }
  };

  render() {
    const {
      onCancel,
      onConfirm,
      destroy,
      renderHtml,
      nameList,
      lang,
    } = this.props;
    const { value, inCoudesOne, inCoudesTwo } = this.state;
    return (
      <section className="pop-pwd">
        <div
          id="popp"
          className="pop-pwd-content"
          role="dialog"
          tabIndex="-1"
          aria-modal="true"
        >
          <Icon
            type="cross"
            onClick={e => onCancel(destroy)}
            role="button"
            aria-label="关闭"
          />
          <p>{this.props.title}</p>
          {!renderHtml && (
            <div>
              <input
                id="mileage-pwd"
                onChange={this.onChange}
                type="password"
                placeholder={lang.memberShip6}
              />
              <div className="pop-pwd-btns">
                <Btn
                  text={lang.confirm}
                  onClick={e => onConfirm(destroy, value)}
                />
                <Btn text={lang.Cancel} onClick={e => onCancel(destroy)} />
              </div>
            </div>
          )}
          {renderHtml && (
            <div>
              <div className="radioT">
                <Radio
                  className="reading"
                  label=""
                  name="inCoudesOne"
                  checked={inCoudesOne}
                  clickEvent={this.readingF('inCoudesOne')}
                />
                <div>{nameList[0]}</div>
              </div>
              <div className="radioP">
                <Radio
                  className="reading"
                  label=""
                  name="inCoudesTwo"
                  checked={inCoudesTwo}
                  clickEvent={this.readingF('inCoudesTwo')}
                />
                <div>{nameList[1]}</div>
              </div>
            </div>
          )}
          {renderHtml && (
            <div className="tipColor">
              <p>{lang.reminder2}</p>
              {lang.memberShip7}
            </div>
          )}
          {renderHtml && (
            <div className="pop-pwd-btns">
              <Btn text={lang.reInput} onClick={e => onCancel(destroy)} />
              <Btn
                text={lang.confirm}
                onClick={e => onConfirm(destroy, [inCoudesOne, inCoudesTwo])}
              />
            </div>
          )}
        </div>
      </section>
    );
  }
}

export default function PopPwd(prop = {}) {
  let div = document.createElement('div');
  document.body.appendChild(div);

  let timeoutEvn = null;
  function keydownFun(e) {
    let dom = document.getElementById('popp');
    const focusableElements = dom.getElementsByTagName('*');
    const firstFocusableElement = focusableElements[0];
    const lastFocusableElement =
      focusableElements[focusableElements.length - 1];
    let isTabPressed =
      e.key === 'Tab' || (e.shiftKey && e.key === 'Tab') || e.keyCode === 9;

    if (!isTabPressed) {
      return;
    }

    if (e.shiftKey) {
      // 如果Shift键被按下，向回切换焦点
      if (document.activeElement === firstFocusableElement) {
        lastFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向后切换行为
      }
    } else {
      // 否则向前切换焦点
      if (document.activeElement === lastFocusableElement) {
        firstFocusableElement.focus();
        e.preventDefault(); // 阻止浏览器默认的向前切换行为
      }
    }
  }
  const destroy = () => {
    if (!div) return;
    clearTimeout(timeoutEvn);
    document.removeEventListener('keydown', keydownFun);
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'false');
    }
    ReactDOM.unmountComponentAtNode(div);
    document.body.removeChild(div);
    div = null;
  };

  ReactDOM.render(<PopPwdComponent {...prop} destroy={destroy} />, div);

  function focus() {
    // 使用原始的 DOM API 显式地聚焦在 text input 上
    // 注意：我们通过访问 “current” 来获得 DOM 节点
    document.getElementById('popp').focus();
    if (document.getElementById('wrapper')) {
      document.getElementById('wrapper').setAttribute('aria-hidden', 'true');
    }
  }
  function trapFocus() {
    document.addEventListener('keydown', keydownFun);
  }
  timeoutEvn = setTimeout(() => {
    focus();
    trapFocus();
  }, 200);
  popPwdQueue.push(destroy);
  return popPwdQueue[popPwdQueue.length - 1];
}

PopPwd.clear = () => {
  if (popPwdQueue && popPwdQueue.length) {
    popPwdQueue.forEach(progess => {
      progess();
    });
    popPwdQueue = [];
  }
};



// WEBPACK FOOTER //
// ./src/components/PopPwd/index.js